const locale = {
  placeholder: '请选择时间',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/zh_CN.js